import { render, staticRenderFns } from "./sso-login.vue?vue&type=template&id=81fb70f0&scoped=true&"
import script from "./sso-login.vue?vue&type=script&lang=js&"
export * from "./sso-login.vue?vue&type=script&lang=js&"
import style0 from "./sso-login.vue?vue&type=style&index=0&id=81fb70f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fb70f0",
  null
  
)

export default component.exports